<template>
  <div>
    <v-dialog v-model="show">
      <v-card>
        <v-card-title>
         <h3>Redirect History - {{ delivery.name }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="show=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
          <v-carousel
            v-if="redirectHistory.length > 0"
            :continuous="false"
            :cycle="cycle"
            hide-delimiters
            v-model="model"
            height="600"
            :show-arrows="true"
          >
            <v-carousel-item
              v-for="(redirect, i) in redirectHistory"
              :key="i"
            >
              <v-sheet
                color="white"
                height="100%"
                tile
              >
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center"
                >
                  <v-container  >
                    <v-row  v-show="model === (redirectHistory.length - 1)" align="center" style="color:black; margin-left: 50%" >
                      <h3  >Current Site</h3>
                    </v-row>
                    <br>
                    <br>
                    <v-row  align="center" style="color:black" >
                      <h3 v-if="isInternalUser && redirect.client_name && redirect.username">{{redirect.client_name + '--'+ redirect.username + '--' + redirect.time}} From Site</h3>
                      <h3 v-else>From Site</h3>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">person</v-icon>
                          </v-list-item-action>
                          <v-list-item-content style="color:black" >
                            <v-list-item-subtitle style="color:black">Name</v-list-item-subtitle>
                            {{redirect.from_name}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">location_on</v-icon>
                          </v-list-item-action>

                          <v-list-item-content  style="color:black" >
                            <v-list-item-subtitle style="color:black">Street</v-list-item-subtitle>
                            {{redirect.from_street1}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">location_on</v-icon>
                          </v-list-item-action>
                          <v-list-item-content style="color:black" >
                            <v-list-item-subtitle style="color:black">Suburb</v-list-item-subtitle>
                            {{redirect.from_suburb}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">location_on</v-icon>
                          </v-list-item-action>
                          <v-list-item-content style="color:black" >
                            <v-list-item-subtitle style="color:black">State</v-list-item-subtitle>
                            {{redirect.from_state}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">location_on</v-icon>
                          </v-list-item-action>

                          <v-list-item-content  style="color:black" >
                            <v-list-item-subtitle style="color:black">Postcode</v-list-item-subtitle>
                            {{redirect.from_postcode}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">phone</v-icon>
                          </v-list-item-action>
                          <v-list-item-content style="color:black" >
                            <v-list-item-subtitle style="color:black">Phone</v-list-item-subtitle>
                            {{redirect.from_phone1}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                    <v-divider color="#42a5f5"></v-divider>
                    <br>
                    <v-row  align="center" style="color:black" >
                      <h3  >To Site</h3>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">person</v-icon>
                          </v-list-item-action>
                          <v-list-item-content style="color:black" >
                            <v-list-item-subtitle style="color:black">Name</v-list-item-subtitle>
                            {{redirect.to_name}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">location_on</v-icon>
                          </v-list-item-action>
                          <v-list-item-content  style="color:black" >
                            <v-list-item-subtitle style="color:black">Street</v-list-item-subtitle>
                            {{redirect.to_street1}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">location_on</v-icon>
                          </v-list-item-action>
                          <v-list-item-content style="color:black" >
                            <v-list-item-subtitle style="color:black">Suburb</v-list-item-subtitle>
                            {{redirect.to_suburb}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">location_on</v-icon>
                          </v-list-item-action>
                          <v-list-item-content style="color:black" >
                            <v-list-item-subtitle style="color:black">State</v-list-item-subtitle>
                            {{redirect.to_state}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">location_on</v-icon>
                          </v-list-item-action>
                          <v-list-item-content  style="color:black" >
                            <v-list-item-subtitle style="color:black">Postcode</v-list-item-subtitle>
                            {{redirect.to_postcode}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="6" md="4" sm="6">
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon color="blue darken-1">phone</v-icon>
                          </v-list-item-action>
                          <v-list-item-content style="color:black" >
                            <v-list-item-subtitle style="color:black">Phone</v-list-item-subtitle>
                            {{redirect.to_phone1}}<br>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
          <h4  v-else style="margin-left: 50px" >Redirect History Record</h4>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="show=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: "RedirectHistoryDialog",
    props: {
      delivery: Object,
      showProp: Boolean
    },
    data() {
      return {
        redirectHistory:[
        ],
        model:0,
        cycle: false,
      }
    },
    computed: {
      show: {
        get() {
          return this.showProp;
        },
        set(value) {
          if (!value) this.$emit('close');
        }
      },
      editPermission() {
        return this.$store.getters['auth/hasPermissionRegionId']('delivery_redirect', this.delivery.region_id);
      },
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      },
      renderedhistory() {
        if (this.history === null || this.history === undefined) {
          this.history = [];
          this.history.unshift({
            from_street1:null,from_suburb:null,from_state:null,
            from_name:null,to_name:null,to_phone1:null,
            from_postcode:null,from_phone1:null,to_street1:null,
            to_suburb:null,to_state:null,to_postcode:null,
          });
          return this.history;
        } else return this.history;
      },
    },
    asyncComputed: {
      async history() {
        if (this.delivery === null) return [];
        return await axios.get(process.env.API_URL + '/deliveries/' + this.delivery.tracking + '/redirect')
            .then((response) => {
              this.redirectHistory = response.data;
              this.model = this.redirectHistory.length - 1;
              return response.data;
            })
            .catch((err) => {
              this.$store.commit('displaySnackbar', 'ERROR loading redirect history');
              return [];
            });
      }
    }
  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/RedirectHistoryDialog.vue